import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    SetCallRailIntegrationIsEnabled as SetCallRailIntegrationIsEnabledMutation,
    SetCallRailIntegrationIsEnabledVariables,
    SetCallRailIntegrationIsEnabledInput,
    GetSessionUser as GetSessionUserQuery,
} from 'nutshell-graphql-types';

import GET_SESSION_USER from '../../../../core/graphql/queries/get-session-user.graphql';

import SET_CALL_RAIL_INTEGRATION_IS_ENABLED from '../mutations/set-callrail-integration-is-enabled.graphql';

export const useSetCallRailIntegrationIsEnabled = (): {
    setCallRailIntegrationIsEnabled: (arg1: SetCallRailIntegrationIsEnabledInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [setCallRailIntegrationIsEnabled, {loading, error}] = useMutation<
        SetCallRailIntegrationIsEnabledMutation,
        SetCallRailIntegrationIsEnabledVariables
    >(SET_CALL_RAIL_INTEGRATION_IS_ENABLED, {
        update: (proxy, mutationResults) => {
            const loggedInUserCache: GetSessionUserQuery | null | undefined = proxy.readQuery({
                query: GET_SESSION_USER,
            });

            if (
                loggedInUserCache &&
                loggedInUserCache.loggedInUser &&
                loggedInUserCache.loggedInUser.phoneIntegrations &&
                mutationResults.data &&
                mutationResults.data.setCallRailIntegrationIsEnabled &&
                mutationResults.data.setCallRailIntegrationIsEnabled.callRailIntegration
            ) {
                const updatedCallRailIntegration =
                    mutationResults.data.setCallRailIntegrationIsEnabled.callRailIntegration;

                const updatedIntegrations = loggedInUserCache.loggedInUser.phoneIntegrations.map(
                    (integration) => {
                        if (
                            integration.integrationType ===
                            updatedCallRailIntegration.integrationType
                        ) {
                            return updatedCallRailIntegration;
                        }

                        return integration;
                    }
                );

                proxy.writeQuery({
                    query: GET_SESSION_USER,
                    data: {
                        loggedInUser: {
                            ...loggedInUserCache.loggedInUser,
                            phoneIntegrations: updatedIntegrations,
                        },
                    },
                });
            }
        },
    });

    return {
        setCallRailIntegrationIsEnabled: (input: SetCallRailIntegrationIsEnabledInput) =>
            setCallRailIntegrationIsEnabled({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
